// isiPhone
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('iphone') !== -1;
})();
